import * as React from 'react';
import * as PropTypes from 'prop-types';
import * as classNames from 'classnames';

import S from './filter-checkbox.module.scss';

const FilterCheckBox = (props) => {
  return (
    <label htmlFor={props.id} className={classNames(S.filterCheckbox, { [S.disabled]: props.isDisabled })}>
      {props.label}
      <input
        type='checkbox'
        id={props.id}
        value={props.value}
        name={props.name}
        disabled={props.isDisabled}
        checked={props.isChecked}
        onChange={props.handleChange}
      />
      <span className={S.checkMark} />
    </label>
  );
};

FilterCheckBox.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number]),
  isDisabled: PropTypes.bool,
  isChecked: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
};

FilterCheckBox.defaultProps = {
  isDisabled: false,
  name: null,
};

export { FilterCheckBox };
